<script lang="ts">
  import { mloc } from "module/utils";
  import GmTab from "./GmTab.svelte";
  import UserTab from "./UserTab.svelte";
  import IndexingTab from "./indexing/IndexingTab.svelte";
  import FiltersTab from "./filters/FiltersTab.svelte";
  import ClientFiltersTab from "./filters/ClientFiltersTab.svelte";

  const tabs = [
    {
      id: "gm",
      title: "SettingsMenuTabGlobal",
      icon: "fas fa-globe",
      hide: !game.user?.isGM,
    },
    {
      id: "user",
      title: "SettingsMenuTabUser",
      icon: "fas fa-user",
    },
    {
      id: "indexing",
      title: "SettingsMenuTabIndexing",
      icon: "fas fa-search",
      hide: !game.user?.isGM,
    },
    {
      id: "filters",
      title: "SettingsMenuTabFilters",
      icon: "fas fa-filter",
      hide: !game.user?.isGM,
    },
    {
      id: "client-filters",
      title: "SettingsMenuTabClientFilters",
      icon: "fas fa-filter",
    },
  ].filter((tab) => !tab.hide);

  let selectedTab: string = $state(tabs[0].id);

  const selectTab = (tabId: string) => () => (selectedTab = tabId);
</script>

<nav class="tabs">
  {#each tabs as tab}
    <button
      role="tab"
      aria-selected={selectedTab === tab.id}
      tabindex="0"
      class:active={selectedTab === tab.id}
      class="item"
      on:click|preventDefault={selectTab(tab.id)}
    >
      <span class="tab-link" class:active={selectedTab === tab.id}>
        <i class={tab.icon}></i>
        {mloc(tab.title)}
      </span>
    </button>
  {/each}
</nav>
<section>
  <GmTab active={selectedTab === "gm"} />
  <UserTab active={selectedTab === "user"} />
  <IndexingTab active={selectedTab === "indexing"} />
  <FiltersTab active={selectedTab === "filters"} />
  <ClientFiltersTab active={selectedTab === "client-filters"} />
</section>

<style>
  nav.tabs {
    margin: 0;
    padding: 0;
    line-height: 2.6;
    align-items: stretch;
    gap: 0;
    border: none;
  }

  nav.tabs .item i {
    font-size: inherit;
  }

  nav.tabs .item {
    color: var(--color-text-primary);
    display: block;
    background-color: rgba(0, 0, 0, 0.06);
    transition:
      border-color 300ms ease-out,
      background-color 100ms ease-out;
    flex-grow: 1;
    margin: 0;
    border: none;
    border-radius: 0;
    border-bottom: 2px solid rgba(0, 0, 0, 0.1);
    cursor: pointer;
  }

  nav.tabs .item:hover,
  nav.tabs .item:active,
  nav.tabs .item:focus,
  nav.tabs .item.active {
    box-shadow: none !important;
    text-shadow: none;
    outline: none;
    border-color: rgba(0, 0, 0, 0.5);
    color: var(--color-text-primary);
  }

  nav.tabs .item.active {
    background-color: transparent;
    border-color: var(--color-warm-2);
    text-shadow: none;
  }

  nav.tabs .item:hover,
  nav.tabs .item:focus {
    background: rgba(255, 255, 255, 0.05);
  }
  section {
    display: flex;
    flex-direction: column;
    overflow: auto;
    flex-grow: 1;
    position: relative;
  }
</style>
